import { useParams } from "react-router";

import { m } from "@vega-core/paraglide/messages";
import { isGPCoInvestPortal } from "@vega-core/utils/global";
import { useFeatureFlagGuard } from "@vega-modules/hooks/useFeatureFlagGuard";
import { CommonPaths } from "@vega-modules/paths";

import { AuditTable } from "../components/AuditTable/AuditTable";
import { CoInvestmentPageHeader } from "../components/CoInvestmentPageHeader/CoInvestmentPageHeader";
import { useAuditData } from "../hooks/useAuditData";
import { useAuditFilters } from "../hooks/useAuditFilters";
import { useDealName } from "../hooks/useDealName";

export const AuditPage = () => {
  useFeatureFlagGuard(
    "gp_co_investment",
    isGPCoInvestPortal ? undefined : CommonPaths.Home,
  );
  const { id: dealId = "" } = useParams<{ id: string }>();

  const { dealName, isLoading: isDealNameLoading } = useDealName(dealId);
  const { RenderFilters, selectedEventNames } = useAuditFilters();
  const { auditEvents, isLoading, paginationElement } = useAuditData({
    dealId,
    eventNames: selectedEventNames,
  });

  return (
    <div className="mt-1">
      <CoInvestmentPageHeader
        description={m.coInvestments_audit_description()}
        fundName={dealName}
        isLoading={isLoading || isDealNameLoading}
        title={m.coInvestments_audit_title()}
      />

      <div className="mt-6 space-y-6">
        {RenderFilters}

        <AuditTable
          data={auditEvents}
          isLoading={isLoading}
          paginationElement={paginationElement}
        />
      </div>
    </div>
  );
};
